import React, { Fragment, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { Grid, TablePagination } from "@mui/material";
import {wordPointsColumns} from "../../../components/constants";

export default function UsersPointsTable({
  scores,
  wordData,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Grid
      container
      direction={"column"}
      alignItems="center"
      justifyContent="center"
      style={{ marginTop: 70 }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "1000px",
        }}
      >
        <span style={{ fontSize: 20, fontWeight: 600, color: "#404746" }}>
          Created By<span>: {wordData?.user?.full_name}</span>
        </span>
      </div>  
      <Grid
        style={{
          border: "1px solid #40474640",
          borderRadius: 12,
          width: "75%",
          marginTop: 24,
        }}
      >
        <Table style={{ border: "none" }}>
          <TableHead style={{ border: "none" }}>
            <TableRow>
              {wordPointsColumns &&
                wordPointsColumns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      border: "none",
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#8086A2",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {scores &&
              scores
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <Fragment>
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        style={{ borderRadius: 20 }}
                      >
                        {wordPointsColumns.map((column) => {
                          const value = row.user[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                border: "none",
                                background: "#F6F6F6",
                                color: "#C84B96",
                                fontSize: 14,
                                fontWeight: column.id == "name" ? 600 : 500,
                                borderRadius:
                                  column.id == "name"
                                    ? "8px 0px 0px 8px"
                                    : column.id == "points"
                                    ? "0px 8px 8px 0px"
                                    : undefined,
                              }}
                            >
                              {column.id == "name"
                                ? `${
                                    row.user?.account_type === "Business"
                                      ? row.user?.name
                                      : row.user.first_name 
                                  }`
                                : column.id === "points"
                                ? row.points
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                      <div style={{ margin: 8 }} />
                    </Fragment>
                  );
                })}
                {scores?.length === 0 ? (
                    <TableRow>
                    <TableCell style={{
                                border: "none",
                                background: "#F6F6F6",
                                color: "#C84B96",
                                fontSize: 14,
                                fontWeight: 600,
                              }}>
                              </TableCell>
                      <TableCell style={{
                                border: "none",
                                background: "#F6F6F6",
                                color: "#C84B96",
                                fontSize: 14,
                                fontWeight: 600,
                              }}>
                              No Data Available
                              </TableCell>
                              <TableCell style={{
                                border: "none",
                                background: "#F6F6F6",
                                color: "#C84B96",
                                fontSize: 14,
                                fontWeight: 600,
                              }}>
                              </TableCell>
                    </TableRow>
                  ) : <></>
                }
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[3, 5, 8]}
          component="div"
          count={scores && scores?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
    </Grid>
  );
}
